module.exports = __webpack_public_path__ + "static/cmac-2022-7d1a917eb6874babbd0891a1408212f4.png";